import app from 'flarum/forum/app';
import registerWidget from '../common/registerWidget';

app.initializers.add('bj-community/bje-quick-links', () => {
  registerWidget(app);
});
